import { BaseApiV2, Methods } from "@newview/infrastructure";

export abstract class DbCenterBaseApiV2 extends BaseApiV2 {
    public get ProxyName(): any {
        return 'DbCenterApi';
    }
}